import styled from 'styled-components';

const Wrapper = styled.div`
  .component_sunburst_canvas {
    height: 400px;
    width: 100%;
  }
`;

export default Wrapper;

export const PieLegendWrapper = styled.div`
  display: flex !important;
  column-gap: 12px;
  margin-bottom: 24px;
  .dot {
    height: 18px;
    width: 18px;
    background-color: ${(props) => {
      return props.dotColor ? props.dotColor : '#333';
    }};
    border-radius: 50%;
    display: inline-block;
  }
`;
